import { Component, h } from 'preact'
import { buildQuestionList, Button, Question } from 'ac-patterns'

const fields = [
  {
    name: 'urlToWrite',
    label: 'The url/data to encode',
    onInput: true,
  },
]

export class NfcApp extends Component {
  constructor(props) {
    super(props)
    this.scanClick = this.scanClick.bind(this)
    this.cancelClick = this.cancelClick.bind(this)
    this.writeClick = this.writeClick.bind(this)
    this.state = {
      urlToWrite: 'https://xchart.com/business-card',
      messages: [],
      mode: 'idle',
    }
    this.abortController = null // Tracks abort controller
  }

  log(message) {
    const newMessages = [...this.state.messages, message]
    if (newMessages.length > 10) {
      newMessages.shift()
    }
    this.setState({ messages: newMessages })
  }

  initReader() {
    if (!this.ndef) {
      this.ndef = new window.NDEFReader()
    }
    return this.ndef
  }

  async scanClick() {
    try {
      const ndef = this.initReader()
      this.abortController = new AbortController() // New controller
      this.setState({ mode: 'reading' })

      await ndef.scan({ signal: this.abortController.signal })
      this.log('> Scan started')

      ndef.addEventListener('readingerror', () => {
        this.log('Argh! Cannot read data from the NFC tag. Try another one?')
      })

      ndef.addEventListener('reading', ({ message, serialNumber }) => {
        this.log(`> Serial Number: ${serialNumber}`)

        if (message.records.length === 0) {
          this.log('> No records found on the tag')
          return
        }

        message.records.forEach((record, index) => {
          let decodedData = ''

          if (record.data instanceof DataView) {
            const uint8Array = new Uint8Array(record.data.buffer)
            decodedData = new TextDecoder().decode(uint8Array)
          } else if (typeof record.data === 'string') {
            decodedData = record.data
          } else {
            decodedData = `[Unsupported data format]`
          }

          this.log(
            `> Record ${index + 1}: Type: ${
              record.recordType
            }, Data: ${decodedData}`
          )
        })
      })
    } catch (error) {
      if (error.name === 'AbortError') {
        this.log('> Scan cancelled')
      } else {
        this.log('Argh! ' + error)
      }
      this.setState({ mode: 'idle' })
    }
  }

  async writeClick() {
    this.log('User clicked write button')
    this.abortController = new AbortController() // New controller for writing
    this.setState({ mode: 'writing' })

    const urlToWrite = this.state.urlToWrite

    try {
      const ndef = this.initReader()
      await ndef.write(
        {
          records: [
            {
              recordType: 'url',
              data: urlToWrite,
            },
          ],
        },
        { signal: this.abortController.signal } // Pass AbortSignal
      )
      this.log('> Wrote ' + urlToWrite)
    } catch (error) {
      if (error.name === 'AbortError') {
        this.log('> Write cancelled')
      } else {
        this.log('Argh! ' + error)
      }
    } finally {
      this.setState({ mode: 'idle' })
    }
  }

  cancelClick() {
    if (this.abortController) {
      this.abortController.abort() // Cancel scan or write
      this.abortController = null
      this.setState({ mode: 'idle' })
      this.log('> Operation cancelled')
    } else {
      this.log('No active operation to cancel')
    }
  }

  render() {
    const processedFields = buildQuestionList(fields, this.state, {})
    const { messages, mode } = this.state

    return (
      <div>
        <div class='bg-white dark-blue flex justify-center'>
          <div class='w-100 mw7 ph2 tl'>
            <h2 class='f2'>NFC Writer / Reader</h2>
            <div>
              {processedFields.map(item => (
                <Question
                  key={item.name}
                  updateValue={val => {
                    this.setState({ [item.name]: val })
                  }}
                  item={item}
                />
              ))}
            </div>

            <div className='mv2 flex items-center gap3'>
              <Button large onClick={this.scanClick} disabled={mode !== 'idle'}>
                Scan
              </Button>
              <Button
                large
                onClick={this.writeClick}
                disabled={mode !== 'idle'}
              >
                Write
              </Button>
              {mode !== 'idle' && (
                <Button large onClick={this.cancelClick}>
                  Cancel
                </Button>
              )}
            </div>

            <div>Messages</div>
            {messages.map((message, i) => (
              <div key={i}>{message}</div>
            ))}
          </div>
        </div>
      </div>
    )
  }
}
